export const placeholderRelatedToVehicle = 'Sonnenkilometer';
export const placeholders = ['Preisersparnis', 'Autarkiegrad', 'Sonnenkilometer', 'CO2Einsparung'];
